import * as React from 'react';
import * as PropTypes from 'prop-types';
/**
 * Represents the PopoverActionsBar component.
 */
export var PopoverActionsBar = React.forwardRef(function (props, ref) {
    var elementRef = React.useRef(null);
    var popoverRef = React.useRef(null);
    React.useImperativeHandle(popoverRef, function () {
        return { props: props, element: elementRef.current };
    });
    React.useImperativeHandle(ref, function () { return popoverRef.current; });
    return (React.createElement("div", { ref: elementRef, className: "k-popover-actions k-actions k-actions-stretched", style: { position: 'relative' } }, props.children));
});
var defaultProps = {};
PopoverActionsBar.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node
    ])
};
PopoverActionsBar.defaultProps = defaultProps;
PopoverActionsBar.displayName = 'KendoReactPopoverActionsBar';
